import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { FaqItem, PUBLIC_FAQ_ITEMS } from './help.faq.data';

@Component({
    selector: 'help-faq',
    template: require('./help.faq.component.html'),
    styles: [require('../personal.account.shared.css'), require('./help.faq.component.css')]
})
export class HelpFaqComponent implements OnInit, OnDestroy {
    readonly allFaqs: FaqItem[] = PUBLIC_FAQ_ITEMS;
    filteredFaqs: FaqItem[] = [];
    searchInput = '';

    constructor(private readonly sanitizer: DomSanitizer) {}

    ngOnInit(): void {
        document.body.classList.add('personal-account-fit');
        this.filteredFaqs = [...this.allFaqs];
    }

    ngOnDestroy(): void {
        document.body.classList.remove('personal-account-fit');
    }

    trust(html: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    applySearch(): void {
        const term = this.searchInput.trim().toLowerCase();
        if (!term) {
            this.filteredFaqs = [...this.allFaqs];
            return;
        }
        this.filteredFaqs = this.allFaqs.filter(
            (f) =>
                f.question.toLowerCase().includes(term) ||
                this.plainAnswerText(f.answerHtml).toLowerCase().includes(term)
        );
    }

    onSearchKeydown(ev: KeyboardEvent): void {
        if (ev.key === 'Enter') {
            this.applySearch();
        }
    }

    private plainAnswerText(html: string): string {
        return html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/account.management/help/help.faq.component.ts